import { api } from './client'

export const listCourses = (pid, params = {}) => {
  const qs = new URLSearchParams(params).toString()
  return api.get(`/courses/programs/${pid}${qs ? `?${qs}` : ''}`).then((r) => r.data)
}
export const getCourse = (pid, courseId) =>
  api.get(`/courses/programs/${pid}/${courseId}`).then((r) => r.data)
export const createCourse = (pid, data) =>
  api.post(`/courses/programs/${pid}`, data).then((r) => r.data)
export const updateCourse = (pid, courseId, data) =>
  api.put(`/courses/programs/${pid}/${courseId}`, data).then((r) => r.data)
export const deleteCourse = (pid, courseId) =>
  api.delete(`/courses/programs/${pid}/${courseId}`).then((r) => r.data)

// ── Module authoring ──
export const createModule = (pid, courseId, data) =>
  api.post(`/courses/programs/${pid}/${courseId}/modules`, data).then((r) => r.data)
// Menulis ulang urutan SEMUA modul sebuah kursus sekaligus. `ids` harus persis
// modul kursus itu; bila tidak cocok (mis. admin lain menambah modul), server
// menolak dengan 400 dan tidak mengubah apa pun.
export const reorderModules = (pid, courseId, ids) =>
  api.put(`/courses/programs/${pid}/${courseId}/modules/order`, { ids }).then((r) => r.data)
export const updateModule = (pid, moduleId, data) =>
  api.put(`/courses/programs/${pid}/modules/${moduleId}`, data).then((r) => r.data)
export const deleteModule = (pid, moduleId) =>
  api.delete(`/courses/programs/${pid}/modules/${moduleId}`).then((r) => r.data)

// ── Lesson authoring ──
export const createLesson = (pid, moduleId, data) =>
  api.post(`/courses/programs/${pid}/modules/${moduleId}/lessons`, data).then((r) => r.data)
export const updateLesson = (pid, lessonId, data) =>
  api.put(`/courses/programs/${pid}/lessons/${lessonId}`, data).then((r) => r.data)
export const deleteLesson = (pid, lessonId) =>
  api.delete(`/courses/programs/${pid}/lessons/${lessonId}`).then((r) => r.data)

// Pengaturan bersama semua unggahan dokumen: laporan byte terkirim (untuk bilah
// kemajuan) dan sinyal pembatalan. `total` bisa kosong kalau peramban tidak
// tahu ukuran badan permintaan, jadi pemanggil perlu siap tanpa itu.
const uploadConfig = ({ onProgress, signal } = {}) => ({
  headers: { 'Content-Type': 'multipart/form-data' },
  signal,
  onUploadProgress: onProgress ? (e) => onProgress(e.loaded, e.total) : undefined,
})

// ── Module documents ──
export const uploadModuleDoc = (pid, moduleId, file, name, opts) => {
  const fd = new FormData()
  fd.append('file', file)
  if (name) fd.append('name', name)
  return api
    .post(`/courses/programs/${pid}/modules/${moduleId}/docs`, fd, uploadConfig(opts))
    .then((r) => r.data)
}
export const deleteModuleDoc = (pid, docId) =>
  api.delete(`/courses/programs/${pid}/module-docs/${docId}`).then((r) => r.data)
export const getModuleDocDownloadUrl = (pid, docId) =>
  api.get(`/courses/programs/${pid}/module-docs/${docId}/download`).then((r) => r.data)
export const getCourseRefDocUrl = (pid, courseId, field) =>
  api.get(`/courses/programs/${pid}/${courseId}/ref-doc-url?field=${field}`).then((r) => r.data)
// Mengosongkan satu slot dokumen referensi (manual_book_url | workbook_url).
export const deleteCourseRefDoc = (pid, courseId, field) =>
  api.delete(`/courses/programs/${pid}/${courseId}/ref-doc`, { params: { field } }).then((r) => r.data)
export const uploadCourseRefDoc = (pid, courseId, field, file, opts) => {
  const fd = new FormData()
  fd.append('file', file)
  fd.append('field', field)
  return api
    .post(`/courses/programs/${pid}/${courseId}/ref-doc`, fd, uploadConfig(opts))
    .then((r) => r.data)
}
// ── Dokumen referensi kursus (daftar yang dinamai admin) ──
// Pengganti dua slot tetap di atas (manual_book_url/workbook_url), yang masih
// ada di server selama masa transisi tetapi tidak lagi dipakai antarmuka.
export const uploadCourseDoc = (pid, courseId, file, name, opts) => {
  const fd = new FormData()
  fd.append('file', file)
  if (name) fd.append('name', name)
  return api
    .post(`/courses/programs/${pid}/${courseId}/docs`, fd, uploadConfig(opts))
    .then((r) => r.data)
}
export const renameCourseDoc = (pid, docId, name) =>
  api.put(`/courses/programs/${pid}/course-docs/${docId}`, { name }).then((r) => r.data)
export const deleteCourseDoc = (pid, docId) =>
  api.delete(`/courses/programs/${pid}/course-docs/${docId}`).then((r) => r.data)
export const getCourseDocDownloadUrl = (pid, docId) =>
  api.get(`/courses/programs/${pid}/course-docs/${docId}/download`).then((r) => r.data)

// Dokumen sebuah pelajaran. Kolom URL di formulir hanya menerima alamat publik
// dari luar; ini jalan untuk berkas milik sendiri, yang disajikan lewat tautan
// bertanda tangan seperti berkas lain di aplikasi ini.
export const uploadLessonDoc = (pid, lessonId, file, opts) => {
  const fd = new FormData()
  fd.append('file', file)
  return api
    .post(`/courses/programs/${pid}/lessons/${lessonId}/doc`, fd, uploadConfig(opts))
    .then((r) => r.data)
}
export const deleteLessonDoc = (pid, lessonId) =>
  api.delete(`/courses/programs/${pid}/lessons/${lessonId}/doc`).then((r) => r.data)

// Tautan berumur pendek (±2 menit) untuk satu kali unduh ke penampil.
//
// Muatan kursus sengaja tidak lagi membawa tautan bertanda tangan untuk dokumen
// pelajaran, jadi ini satu-satunya jalan mendapatkannya — dan diminta sesaat
// sebelum dokumennya benar-benar dibaca, bukan saat daftar pelajaran dimuat.
export const getLessonDocUrl = (pid, lessonId) =>
  api.get(`/courses/programs/${pid}/lessons/${lessonId}/doc-url`).then((r) => r.data)

export const setLessonProgress = (pid, lessonId, completed) =>
  api.post(`/courses/programs/${pid}/lessons/${lessonId}/progress`, { completed })

// Jaring pengaman kelas: menandai satu pelajaran selesai untuk SELURUH peserta
// terdaftar. Hanya staf. Peserta yang lupa menekan "Mark complete" kehilangan
// posttest-nya — dan karenanya sertifikatnya — tanpa galat apa pun.
export const markLessonCompleteForAll = (pid, lessonId, completed = true) =>
  api.post(`/courses/programs/${pid}/lessons/${lessonId}/progress/all`, { completed }).then((r) => r.data)
export const getMyProgress = (pid) =>
  api.get(`/courses/programs/${pid}/my-progress`).then((r) => r.data)
